import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { useRouter } from 'next/router'
import { Eye } from 'lucide-react'

/** Shown to a signed-in admin who opened a page with ?preview=1. */
export const PreviewBanner: FC = (): ReactNode => {
    const router = useRouter()
    const [path, search = ''] = router.asPath.split('?')
    const params = new URLSearchParams(search)

    params.delete('preview')

    const exitHref = params.toString() ? `${path}?${params.toString()}` : path

    return (
        <div className='fixed inset-x-0 top-0 z-50 flex h-10 items-center justify-center gap-3 bg-burgundy px-4 text-xs text-ivory'>
            <Eye className='size-4 shrink-0' aria-hidden='true' />

            <span className='truncate'>
                Preview mode: drafts and scheduled items are visible to you only.
            </span>

            <Link href='/admin' className='shrink-0 underline underline-offset-2 hover:text-gold'>
                Admin
            </Link>

            <Link href={exitHref} className='shrink-0 underline underline-offset-2 hover:text-gold'>
                Exit preview
            </Link>
        </div>
    )
}
